import { apiClient } from "@/modules/shared/utils/apiClient";

export type GetReschedulePreviewResponse = {
  success: boolean;
  customer: {
    id: number;
    fullName: string;
    email: string;
  };
  sessionId: number;
  sessionUrl: string;
  source: string;
  env: string;
  coach: {
    id: number;
    userId: number;
  };
  coachName: string;
  coachEmail: string;
  customerEmail: string;
  originalSessionId: number;
  originalSessionStart: string;
  originalSessionEnd: string;
  utmMetadata: {
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;
  };
};

export const getReschedulePreview = (rescheduleUuid: string) => {
  const params = new URLSearchParams({ rescheduleUuid }).toString();

  return apiClient.get<GetReschedulePreviewResponse>(
    `/coaching-session/reschedule/preview?${params}`,
  );
};
